import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-347676b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_2 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    onOnShown: _ctx.onShown,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", {
        class: "RoleCreateEditDialog_roleSubGrid",
        id: _ctx.policySubGridDomId
      }, null, 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onOnShown"]))
}